// extracted by mini-css-extract-plugin
export default {"container":"RequirementFormPage_container__DxD2K","loading":"RequirementFormPage_loading__97gpZ"};